module.exports = __webpack_public_path__ + "static/media/6.374c2baf.jpg";